// LGS Ders ve Konu Kategorileri

export interface LGSSubject {
  value: string
  label: string
  color: string
  icon: string
  topics: LGSTopic[]
}

export interface LGSTopic {
  value: string
  label: string
  description?: string
}

// LGS Ders Kategorileri ve Konuları
export const LGS_SUBJECTS: LGSSubject[] = [
  {
    value: 'turkce',
    label: 'Türkçe',
    color: 'bg-green-500',
    icon: '✏️',
    topics: [
      { value: 'sozcukte-anlam', label: 'Sözcükte Anlam', description: 'Kelimelerin anlamları ve kullanımları' },
      { value: 'cumlede-anlam', label: 'Cümlede Anlam', description: 'Cümle içindeki anlam ilişkileri' },
      { value: 'parcada-anlam', label: 'Parçada Anlam', description: 'Metin parçalarının anlamsal çözümlemesi' },
      { value: 'parcada-anlatim', label: 'Parçada Anlatım', description: 'Metinlerdeki anlatım teknikleri' },
      { value: 'parcada-yapi', label: 'Parçada Yapı', description: 'Metin yapısı ve organizasyonu' },
      { value: 'sozel-mantik', label: 'Sözel Mantık', description: 'Mantıksal çıkarım ve akıl yürütme' },
      { value: 'tablo-grafik-gorsel', label: 'Tablo, Grafik ve Görsel Yorumlama', description: 'Görsel materyallerin yorumlanması' },
      { value: 'yazim-kurallari', label: 'Yazım Kuralları', description: 'Türkçe yazım kuralları ve uygulamaları' },
      { value: 'noktalama', label: 'Noktalama İşaretleri', description: 'Noktalama işaretlerinin doğru kullanımı' },
      { value: 'metin-turleri', label: 'Metin Türleri', description: 'Farklı metin türleri ve özellikleri' },
      { value: 'soz-sanatlari', label: 'Söz Sanatları', description: 'Edebî sanatlar ve kullanımları' },
      { value: 'fiilimsiler', label: 'Fiilimsiler', description: 'Fiilimsi türleri ve kullanımları' },
      { value: 'cumlenin-ogeleri', label: 'Cümlenin Öğeleri', description: 'Cümle öğeleri ve görevleri' },
      { value: 'fiilde-cati', label: 'Fiilde Çatı', description: 'Fiil çatıları ve özellikleri' },
      { value: 'cumle-turleri', label: 'Cümle Türleri', description: 'Cümle türleri ve sınıflandırması' },
      { value: 'anlatim-bozukluklari', label: 'Anlatım Bozuklukları', description: 'Yaygın anlatım hataları ve düzeltmeleri' },
      { value: 'deyim-atasozleri', label: 'Deyim ve Atasözleri', description: 'Türkçe deyimler ve atasözleri' }
    ]
  },
  {
    value: 'fen',
    label: 'Fen Bilimleri',
    color: 'bg-purple-500',
    icon: '🧪',
    topics: [
      { value: 'mevsimler-iklim', label: 'Mevsimler ve İklim', description: 'İklim olayları ve mevsimsel değişimler' },
      { value: 'dna-genetik', label: 'DNA ve Genetik Kod', description: 'Genetik bilimi ve DNA yapısı' },
      { value: 'basinc', label: 'Basınç', description: 'Basınç kavramı ve uygulamaları' },
      { value: 'madde-endustri', label: 'Madde ve Endüstri', description: 'Maddenin özellikleri ve endüstriyel uygulamalar' },
      { value: 'basit-makineler', label: 'Basit Makineler', description: 'Temel makine türleri ve çalışma prensipleri' },
      { value: 'enerji-donusumleri', label: 'Enerji Dönüşümleri ve Çevre Bilimi', description: 'Enerji türleri ve çevresel etkiler' },
      { value: 'elektrik-yukleri', label: 'Elektrik Yükleri ve Elektrik Enerjisi', description: 'Elektrik kavramları ve enerji' }
    ]
  },
  {
    value: 'inkilap',
    label: 'T.C. İnkılap Tarihi ve Atatürkçülük',
    color: 'bg-red-500',
    icon: '🏛️',
    topics: [
      { value: 'kahraman-doguyor', label: 'Bir Kahraman Doğuyor', description: 'Atatürk\'ün doğumu ve gençlik yılları' },
      { value: 'milli-uyanis', label: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar', description: 'Milli mücadele öncesi gelişmeler' },
      { value: 'istiklal-olum', label: 'Ya İstiklal Ya Ölüm!', description: 'Kurtuluş Savaşı dönemi' },
      { value: 'ataturkculuk-cagdaslasma', label: 'Atatürkçülük ve Çağdaşlaşan Türkiye', description: 'Cumhuriyet dönemi reformları' },
      { value: 'demokratiklesme', label: 'Demokratikleşme Çabaları', description: 'Türkiye\'de demokrasi gelişimi' },
      { value: 'dis-politika', label: 'Atatürk Dönemi Türk Dış Politikası', description: 'Erken Cumhuriyet dönemi dış ilişkiler' },
      { value: 'vefat-sonrasi', label: 'Atatürk\'ün Vefatı ve Sonrası', description: 'Atatürk sonrası dönem' }
    ]
  },
  {
    value: 'ingilizce',
    label: 'İngilizce',
    color: 'bg-orange-500',
    icon: '🗣️',
    topics: [
      { value: 'friendship', label: 'Friendship', description: 'Arkadaşlık konulu kelime ve ifadeler' },
      { value: 'teen-life', label: 'Teen Life', description: 'Genç yaşamı ve aktiviteleri' },
      { value: 'in-kitchen', label: 'In The Kitchen', description: 'Mutfak ve yemek konulu kelimeler' },
      { value: 'on-phone', label: 'On The Phone', description: 'Telefon konuşmaları ve iletişim' },
      { value: 'internet', label: 'The Internet', description: 'İnternet ve teknoloji terimleri' },
      { value: 'adventures', label: 'Adventures', description: 'Macera ve seyahat konulu kelimeler' },
      { value: 'tourism', label: 'Tourism', description: 'Turizm ve tatil aktiviteleri' },
      { value: 'chores', label: 'Chores', description: 'Ev işleri ve günlük aktiviteler' },
      { value: 'science', label: 'Science', description: 'Bilim ve teknoloji terimleri' },
      { value: 'natural-forces', label: 'Natural Forces', description: 'Doğal güçler ve olaylar' }
    ]
  },
  {
    value: 'din',
    label: 'Din Kültürü ve Ahlak Bilgisi',
    color: 'bg-teal-500',
    icon: '📿',
    topics: [
      { value: 'kader-inanci', label: 'Kader İnancı', description: 'İslam dininde kader kavramı' },
      { value: 'zekat-sadaka', label: 'Zekât ve Sadaka', description: 'İslam\'ın sosyal yardımlaşma esasları' },
      { value: 'din-hayat', label: 'Din ve Hayat', description: 'Dinin günlük yaşamdaki yeri' },
      { value: 'hz-muhammed', label: 'Hz. Muhammed\'in Örnekliği', description: 'Peygamber efendimizin hayatı ve örnekliği' },
      { value: 'kuran-kerim', label: 'Kur\'an-ı Kerim ve Özellikleri', description: 'Kutsal kitabımızın özellikleri ve önemi' }
    ]
  }
]

// Helper functions
export const getSubjectByValue = (value: string): LGSSubject | undefined => {
  return LGS_SUBJECTS.find(subject => subject.value === value)
}

export const getTopicByValue = (subjectValue: string, topicValue: string): LGSTopic | undefined => {
  const subject = getSubjectByValue(subjectValue)
  return subject?.topics.find(topic => topic.value === topicValue)
}

export const getAllTopics = (): LGSTopic[] => {
  return LGS_SUBJECTS.flatMap(subject => subject.topics)
}

export const getTopicsBySubject = (subjectValue: string): LGSTopic[] => {
  const subject = getSubjectByValue(subjectValue)
  return subject?.topics || []
}

// Subject colors for UI
export const SUBJECT_COLORS = {
  turkce: 'bg-green-500',
  fen: 'bg-purple-500',
  inkilap: 'bg-red-500',
  ingilizce: 'bg-orange-500',
  din: 'bg-teal-500'
} as const

// Difficulty levels
export const DIFFICULTY_LEVELS = [
  { value: 'easy', label: 'Kolay', color: 'bg-green-100 text-green-800' },
  { value: 'medium', label: 'Orta', color: 'bg-yellow-100 text-yellow-800' },
  { value: 'hard', label: 'Zor', color: 'bg-red-100 text-red-800' }
] as const